import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { legacyAllSmartLinksTarget } from './smartLinksOverviewQuery';

/**
 * The old full list `/app/all` is gone: the SmartLinks page shows every page now (owner request
 * 2026-10-19). An old link or bookmark opens the SmartLinks page with its search and tab. It
 * replaces the history entry, so Back does not return to the dead address.
 */
export const AllSmartLinksRedirect: React.FC = () => {
  const { search } = useLocation();
  return <Navigate to={legacyAllSmartLinksTarget(search)} replace />;
};
